import React from 'react';
import FormHeader from '../components/FormHeader';
import ContactForm from '../components/ContactForm';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-dark-950">
      {/* Main Content */}
      <div className="flex-1 flex items-start mt-16 justify-center">
        <div className="w-full max-w-2xl mx-auto px-4">
          {/* Contact Form Container */}
          <div className="bg-black/50 backdrop-blur-sm rounded-3xl p-10 shadow-xl border border-gray-700/30">
            <FormHeader
              title="Contact Us"
              subtitle="We'd love to hear from you. Send us a message and we'll respond as soon as possible."
            />

            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
